import { lazy, Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { Capacite } from './auth/permissions';
import { ProtectionCapacite, ProtectionRoute } from './auth/ProtectionRoute';
import { AbonnementsPage } from './pages/AbonnementsPage';
import { ClientsPage } from './pages/ClientsPage';
import { ConsommationPage } from './pages/ConsommationPage';
import { DonneesAppareilPage } from './pages/DonneesAppareilPage';
import { SavPage } from './pages/SavPage';
import { Coquille } from './components/Coquille';
import { AppareilPage } from './pages/AppareilPage';
import { AuditPage } from './pages/AuditPage';
import { ConnexionPage } from './pages/ConnexionPage';
import { ExploitationPage } from './pages/ExploitationPage';
import { ExploitationsPage } from './pages/ExploitationsPage';
import { ImportStockPage } from './pages/ImportStockPage';
import { IntrouvablePage } from './pages/IntrouvablePage';
import { AssistantPage } from './pages/AssistantPage';
import { LaboPage } from './pages/LaboPage';

import { StockPage } from './pages/StockPage';
import { SupervisionPage } from './pages/SupervisionPage';
import { TableauDeBordPage } from './pages/TableauDeBordPage';

// esptool-js (flasheur USB) : chargé seulement quand on ouvre la page
const ProgrammationPage = lazy(() =>
  import('./pages/ProgrammationPage').then((m) => ({ default: m.ProgrammationPage })),
);

/** Coquille des écrans authentifiés. */
function Interieur(): JSX.Element {
  return (
    <ProtectionRoute>
      <Coquille>
        <Outlet />
      </Coquille>
    </ProtectionRoute>
  );
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/connexion" element={<ConnexionPage />} />

      <Route element={<Interieur />}>
        <Route
          index
          element={
            <ProtectionCapacite capacite={Capacite.SUPERVISER}>
              <TableauDeBordPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="supervision"
          element={
            <ProtectionCapacite capacite={Capacite.SUPERVISER}>
              <SupervisionPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="stock"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_STOCK}>
              <StockPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="stock/import"
          element={
            <ProtectionCapacite capacite={Capacite.IMPORTER_STOCK}>
              <ImportStockPage />
            </ProtectionCapacite>
          }
        />

        {/* Adressée par NUMÉRO DE SÉRIE et non par UUID : c'est l'identifiant qu'un client lit
            au téléphone et que le support colle dans la barre de recherche. */}
        <Route
          path="appareils/:numeroSerie"
          element={
            <ProtectionCapacite capacite={Capacite.DIAGNOSTIQUER}>
              <AppareilPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="appareils/:numeroSerie/donnees"
          element={
            <ProtectionCapacite capacite={Capacite.DIAGNOSTIQUER}>
              <DonneesAppareilPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="assistant"
          element={
            <ProtectionCapacite capacite={Capacite.INTERROGER_ASSISTANT}>
              <AssistantPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="programmation"
          element={
            <ProtectionCapacite capacite={Capacite.IMPORTER_STOCK}>
              <Suspense fallback={null}>
                <ProgrammationPage />
              </Suspense>
            </ProtectionCapacite>
          }
        />

        <Route
          path="labo"
          element={
            <ProtectionCapacite capacite={Capacite.DIAGNOSTIQUER}>
              <LaboPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="exploitations"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_EXPLOITATIONS}>
              <ExploitationsPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="exploitations/:id"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_EXPLOITATIONS}>
              <ExploitationPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="clients"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_CLIENTS}>
              <ClientsPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="consommation"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_CLIENTS}>
              <ConsommationPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="abonnements"
          element={
            <ProtectionCapacite capacite={Capacite.GERER_ABONNEMENTS}>
              <AbonnementsPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="support"
          element={
            <ProtectionCapacite capacite={Capacite.TRAITER_SAV}>
              <SavPage />
            </ProtectionCapacite>
          }
        />

        <Route
          path="audit"
          element={
            <ProtectionCapacite capacite={Capacite.CONSULTER_AUDIT}>
              <AuditPage />
            </ProtectionCapacite>
          }
        />

        <Route path="*" element={<IntrouvablePage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
